import type { ReactNode } from "react";

import clsx from "clsx";

import { ArrowBackIcon } from "../../icons/arrow-back";
import { CloseIcon } from "../../icons/close";
import { Button } from "../button";

import styles from "./fullscreen-layout.module.css";

export type FullscreenLayoutVariant = "default" | "wide";

type WithBackButton =
	{ prev: () => void; showBackButton: true } | { prev?: () => void; showBackButton: false };

type FullscreenLayoutProps = {
	children: ReactNode;
	hideCloseButton?: boolean;
	layout?: FullscreenLayoutVariant;
	onClose: () => void;
} & WithBackButton;

export function FullscreenLayout({
	children,
	hideCloseButton = false,
	layout = "default",
	onClose,
	prev,
	showBackButton,
}: FullscreenLayoutProps): ReactNode {
	return (
		<section className={styles.fullscreen}>
			<header className={styles.header}>
				{showBackButton && (
					<Button
						data-testid="flow-back-button"
						iconOnly
						onPress={prev}
						variant="secondary"
					>
						<ArrowBackIcon />
					</Button>
				)}
				{!hideCloseButton && (
					<Button
						className={styles.closeButton}
						data-testid="flow-close-button"
						iconOnly
						onPress={onClose}
						variant="secondary"
					>
						<CloseIcon />
					</Button>
				)}
			</header>
			<div className={clsx(styles.content, styles[layout])} data-testid="flow-content">
				{children}
			</div>
		</section>
	);
}
